import { render, staticRenderFns } from "./TerminalAnswer.vue?vue&type=template&id=2a81f29f&scoped=true&"
import script from "./TerminalAnswer.vue?vue&type=script&lang=js&"
export * from "./TerminalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TerminalAnswer.vue?vue&type=style&index=0&id=2a81f29f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81f29f",
  null
  
)

export default component.exports